import React from "react";
import styles from "components/Input/input.module.scss";

const AIText = ({ children, className = '' }) => {
    return <p className={`fw-500 fs-17 fs-15--mob ${className} ${styles.title}`}>{children}</p>
};

export default AIText;

